import React from "react"
import { HStack, Text, Center } from "@chakra-ui/react"

export const Header = ({ years, setCurrentYear, currentYear }) => (
  <HStack justify="center" px={16} pt={4} spacing={0}>
    {years.map(year => {
      const isCurrentYear = currentYear === year

      return (
        <Center
          px={5}
          w="70px"
          py={0}
          key={year}
          pos="relative"
          zIndex={10}
          onClick={() => setCurrentYear(year)}
          cursor="pointer"
          bg={isCurrentYear ? "secondary" : undefined}
          border="1px solid #fff"
        >
          <Text
            as="span"
            color={isCurrentYear ? "dark_blue" : "white"}
            fontWeight={"bold"}
            fontSize="md"
            fontFamily="CocoSharpL-Bold"
            letterSpacing="widest"
            mt={1}
          >
            {year}
          </Text>
        </Center>
      )
    })}
  </HStack>
)
